import * as types from './actionTypes';

export function updateViewerMode(viewerMode) {
    return function (dispatch) {
        dispatch({ type: types.UPDATE_MODE_SUCCESS, viewerMode });
    };
}
